import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installGuards } from './lib/antipiracy';
import './styles.css';

installGuards();
createRoot(document.getElementById('root')!).render(<App />);
